import { client } from "./index";

// Shopper accounts for this store (/api/storefront/auth). Signing up emails a code first; register sends it as `otp`.
export const sendSignupOtp = (email, phone) => client.post("/storefront/auth/register/otp", { email, phone }).then((res) => res.data);
export const register = (payload) => client.post("/storefront/auth/register", payload).then((res) => res.data);

// payload: { login: "email or mobile number", password }
export const login = (payload) => client.post("/storefront/auth/login", payload).then((res) => res.data);

export const getMe = () => client.get("/storefront/auth/me").then((res) => res.data.user);

export const updateProfile = (payload) => client.put("/storefront/auth/profile", payload).then((res) => res.data.user);

export const changePassword = (payload) => client.post("/storefront/auth/change-password", payload).then((res) => res.data);

export const logout = () => client.post("/storefront/auth/logout").then((res) => res.data);

export const forgotPassword = (login) => client.post("/storefront/auth/forgot-password", { login }).then((res) => res.data);

// payload: { login, code, password }
export const resetPassword = (payload) => client.post("/storefront/auth/reset-password", payload).then((res) => res.data);

// Guest checkout: a name and an email confirmed with a code, no password. 409 { hasAccount } when the email has an
// account on this store, which must log in instead.
export const sendGuestOtp = (name, email) => client.post("/storefront/auth/guest/otp", { name, email }).then((res) => res.data);

export const verifyGuestOtp = (name, email, otp) => client.post("/storefront/auth/guest/verify", { name, email, otp }).then((res) => res.data);

// Login with a one-time code emailed to the account's email
export const sendLoginOtp = (email) => client.post("/storefront/auth/otp/send", { email }).then((res) => res.data);

export const verifyLoginOtp = (email, otp) => client.post("/storefront/auth/otp/verify", { email, otp }).then((res) => res.data);
